import React, { useEffect, useState, useMemo } from "react";
import { useOption } from "../../context/OptionContext";
import { CiSearch } from "react-icons/ci";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import MaxPainChart from "../MaxPainChart/MaxPainChart";
import { FaSpinner } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import { useStockName } from "../../context/StockNameContext";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";
const MaxPainPage = () => {
  const {
    fetchBySymbol,
    loading,
    error,
    pcr,
    meta,
    expiries,
    optionData,
    selectedExpiry,
    setSelectedExpiry,
    setExpiry,
    fetchByIndex,
    fetchByAsset,
  } = useOption();
  const { stockName, getNameBySymbol } = useMarketIndicators();
  const [activeSecurityId, setActiveSecurityId] = useState(null);
  const [userTriggered, setUserTriggered] = useState(false);

  //   const [symbol, setSymbol] = useState("");
  const [activeSymbol, setActiveSymbol] = useState("");
  const [lastFetchType, setLastFetchType] = useState(null);
  const [selectDropdown, setSelectDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState("");
  const [contract, setContract] = useState("");
  const { symbol, type, securityId } = useParams();

  const formattedSymbol = symbol?.trim().toUpperCase();
  const formattedType = type?.trim().toUpperCase();

  const formattedSecurityId = securityId ? Number(securityId) : null;
  const navigate = useNavigate();
  // useEffect(() => {
  //   fetchBySymbol(symbol);
  // }, [symbol]);
  // useEffect(() => {
  //   if (!formattedSymbol || !formattedType) return;

  //   if (formattedType === "INDEX") {
  //     fetchByIndex(formattedSymbol);
  //     return;
  //   }

  //   fetchBySymbol(formattedSymbol);
  // }, [formattedSymbol, formattedType]);
  const { fetchStock, stockData } = useStockName();

  // useEffect(() => {
  //   if (!formattedSymbol || formattedType !== "STOCK") return;

  //   getNameBySymbol(formattedSymbol);
  // }, [formattedSymbol, formattedType]);
  useEffect(() => {
    if (!formattedSymbol || !formattedType) return;

    const loadMaxPainData = async () => {
      try {
        if (formattedType === "INDEX") {
          await fetchByIndex(formattedSymbol);
          return;
        }

        if (Number.isInteger(formattedSecurityId) && formattedSecurityId > 0) {
          setActiveSecurityId(formattedSecurityId);

          await Promise.all([
            fetchBySymbol({
              symbol: formattedSymbol,
              securityId: formattedSecurityId,
            }),
            getNameBySymbol(formattedSymbol),
          ]);

          return;
        }

        // Fallback for an older URL without securityId
        await Promise.all([
          fetchBySymbol(formattedSymbol),
          getNameBySymbol(formattedSymbol),
        ]);
      } catch (error) {
        console.error("MaxPain data loading failed:", error);
      }
    };

    loadMaxPainData();
  }, [formattedSymbol, formattedType, formattedSecurityId]);
  // useEffect(() => {
  //   if (!formattedSymbol || !formattedType) return;

  //   const loadOptionData = async () => {
  //     await fetchByAsset({
  //       symbol: formattedSymbol,
  //       type: formattedType,
  //     });

  //     if (formattedType === "STOCK") {
  //       await getNameBySymbol(formattedSymbol);
  //     }
  //   };

  //   loadOptionData();
  // }, [formattedSymbol, formattedType]);
  // useEffect(() => {
  //   if (formattedSymbol || userTriggered) return;

  //   if (!activeSymbol && !selectedIndex) {
  //     const defaultIndex = "NIFTY";

  //     setContract(defaultIndex);
  //     setSelectedIndex(defaultIndex);
  //     setActiveSymbol(defaultIndex);
  //     setLastFetchType("index");
  //     setSelectDropdown(true);

  //     fetchByIndex(defaultIndex);
  //   }
  // }, [
  //   formattedSymbol,
  //   userTriggered,
  //   activeSymbol,
  //   selectedIndex,
  // ]);

  console.log("Stock name", stockData);
  console.log("Pcr data", pcr);

  const builtUpStyles = (signal) => {
    switch (signal) {
      case "LB":
        return { bg: "#d4f7e6", color: "#008A3E" };
      case "SB":
        return { bg: "#ffd4d4", color: "#C53030" };
      case "SC":
        return { bg: "#dce8ff", color: "#0047FF" };
      case "LW":
        return { bg: "#ffeac7", color: "#C68A14" };
      default:
        return { bg: "#f2f2f2", color: "#444" };
    }
  };
  function getBuiltUp(changeInOI, priceChange) {
    if (changeInOI > 0 && priceChange > 0) return "LB"; // Long Built-Up
    if (changeInOI > 0 && priceChange < 0) return "SB"; // Short Built-Up
    if (changeInOI < 0 && priceChange > 0) return "SC"; // Short Covering
    if (changeInOI < 0 && priceChange < 0) return "LW"; // Long Unwinding
    return "-";
  }
  const oc = optionData?.data?.oc || {};
  const rows = Object.keys(oc)
    .map((strike) => {
      const ce = oc[strike]?.ce;
      const pe = oc[strike]?.pe;

      // -------- CALL --------
      const ceOIChange = ce?.previous_oi != null ? ce.oi - ce.previous_oi : 0;

      const ceOIPercent =
        ce?.previous_oi > 0
          ? +(((ce.oi - ce.previous_oi) / ce.previous_oi) * 100).toFixed(2)
          : 0;

      const ceLtpPercent =
        ce?.previous_close_price > 0
          ? +(
              ((ce.last_price - ce.previous_close_price) /
                ce.previous_close_price) *
              100
            ).toFixed(2)
          : 0;

      // -------- PUT --------
      const peOIChange = pe?.previous_oi != null ? pe.oi - pe.previous_oi : 0;

      const peOIPercent =
        pe?.previous_oi > 0
          ? +(((pe.oi - pe.previous_oi) / pe.previous_oi) * 100).toFixed(2)
          : 0;

      const peLtpPercent =
        pe?.previous_close_price > 0
          ? +(
              ((pe.last_price - pe.previous_close_price) /
                pe.previous_close_price) *
              100
            ).toFixed(2)
          : 0;

      return {
        strike: Number(strike),

        CE: ce
          ? {
              oi: ce.oi,
              oiChange: ceOIChange,
              oiPercent: ceOIPercent,
              volume: ce.volume,
              iv: ce.implied_volatility,
              ltp: ce.last_price,
              ltpPercent: ceLtpPercent, // ✅ NEW
            }
          : null,

        PE: pe
          ? {
              oi: pe.oi,
              oiChange: peOIChange,
              oiPercent: peOIPercent,
              volume: pe.volume,
              iv: pe.implied_volatility,
              ltp: pe.last_price,
              ltpPercent: peLtpPercent, // ✅ NEW
            }
          : null,
      };
    })
    // ✅ lowest → highest strike (NSE style)
    .sort((a, b) => a.strike - b.strike);
  const totCEVol = rows.reduce((sum, row) => sum + (row.CE?.volume || 0), 0);

  const totPEVol = rows.reduce((sum, row) => sum + (row.PE?.volume || 0), 0);

  function calculateMaxPainFromRows(rows, underlying) {
    if (!rows?.length) return null;

    const validRows = rows.filter(
      (r) => (r.CE?.oi || 0) > 0 || (r.PE?.oi || 0) > 0,
    );

    if (!validRows.length) return null;

    const strikes = validRows.map((r) => r.strike);

    let minPain = Infinity;
    let maxPainStrike = null;

    strikes.forEach((strike) => {
      let pain = 0;

      validRows.forEach((row) => {
        const s = row.strike;
        const ceOI = row.CE?.oi || 0;
        const peOI = row.PE?.oi || 0;

        if (strike > s) pain += (strike - s) * ceOI;
        if (strike < s) pain += (s - strike) * peOI;
      });

      if (pain < minPain) {
        minPain = pain;
        maxPainStrike = strike;
      }
    });

    return maxPainStrike;
  }
  const underlying = optionData?.data?.last_price ?? 0;
  const maxPain = calculateMaxPainFromRows(rows, underlying);

  const ceMaxRow = rows.find((r) => r.strike === maxPain)?.CE;
  const peMaxRow = rows.find((r) => r.strike === maxPain)?.PE;
  const ceMaxRowBuiltUp = getBuiltUp(ceMaxRow?.oiChange, ceMaxRow?.ltpPercent);

  const peMaxRowBuiltUp = getBuiltUp(peMaxRow?.oiChange, peMaxRow?.ltpPercent);

  const builtUpStyleCE = builtUpStyles(ceMaxRowBuiltUp);
  const builtUpStylePE = builtUpStyles(peMaxRowBuiltUp);

  const getPCRSentiment = (value) => {
    if (value < 0.7) return { label: "Bearish", color: "#ef4444" };
    if (value <= 1) return { label: "Neutral", color: "#9ca3af" };
    return { label: "Bullish", color: "#22c55e" };
  };

  const getCOIPCRSentiment = (value) => {
    if (value < 0.7) return { label: "Bearish", color: "#ef4444" };
    if (value <= 1) return { label: "Neutral", color: "#9ca3af" };
    return { label: "Bullish", color: "#22c55e" };
  };
  const green = "#22c55e";
  const red = "#ef4444";
  const grey = "#9ca3af";

  const getPCRColor = (v) => {
    if (v < 0.7) return red;
    if (v <= 1) return grey;
    return green;
  };

  const getStrengthColor = (v) => (v >= 0 ? green : red);

  const pcrSentiment = getPCRSentiment(pcr?.value);
  const coiSentiment = getCOIPCRSentiment(pcr?.coiPCR);

  //   useEffect(() => {
  //     // Load NIFTY by default on first visit
  //     if (!activeSymbol && !selectedIndex) {
  //       const defaultIndex = "NIFTY";

  //       setContract(defaultIndex);
  //       setSelectedIndex(defaultIndex);
  //       setActiveSymbol(defaultIndex);
  //       setLastFetchType("index");
  //       setSelectDropdown(true);
  //       // setSelectedStrike("");

  //       fetchByIndex(defaultIndex);
  //     }
  //   }, [activeSymbol, selectedIndex]);
  //   const handleExpiryChange = async (e) => {
  //     const expiry = e.target.value;

  //     // setSelectedStrike("");
  //     // setSelectDropdown(false);

  //     await setExpiry(expiry);
  //   };
  const BUILT_UP_META = {
    LB: {
      label: "Long Built-Up",
      signal: "Bullish",
      description: "Open Interest ↑ and Price ↑",
      color: "#008A3E",
      bg: "#D4F7E6",
    },
    SB: {
      label: "Short Built-Up",
      signal: "Bearish",
      description: "Open Interest ↑ and Price ↓",
      color: "#C53030",
      bg: "#FFE1E1",
    },
    SC: {
      label: "Short Covering",
      signal: "Bullish",
      description: "Open Interest ↓ and Price ↑",
      color: "#0047FF",
      bg: "#E6EEFF",
    },
    LW: {
      label: "Long Unwinding",
      signal: "Bearish",
      description: "Open Interest ↓ and Price ↓",
      color: "#C68A14",
      bg: "#FFF3CD",
    },
  };
  const ceBuiltUp = getBuiltUp(ceMaxRow?.oiChange, ceMaxRow?.ltpPercent);
  const peBuiltUp = getBuiltUp(peMaxRow?.oiChange, peMaxRow?.ltpPercent);

  const ceBuiltUpMeta = BUILT_UP_META[ceBuiltUp];
  const peBuiltUpMeta = BUILT_UP_META[peBuiltUp];
  const formatNumber = (num) => {
    if (num % 1 !== 0) {
      return num?.toFixed(2);
    }
    return num;
  };
  //   const oiChartData = useMemo(() => {
  //     if (!rows?.length) return [];

  //     return rows.map((row) => ({
  //       strike: row.strike,
  //       callOI: row.CE?.oi || 0, // positive
  //       putOI: -(row.PE?.oi || 0), // negative
  //     }));
  //   }, [rows]);
  const oiChartData = useMemo(() => {
    if (!rows?.length) return [];

    return rows
      .filter(
        (row) => (row.CE?.oi || 0) > 0 || (row.PE?.oi || 0) > 0, // ✅ ONLY where OI exists
      )
      .map((row) => ({
        strike: row.strike, // ✅ REAL STRIKE
        callOI: row.CE?.oi || 0,
        putOI: row.PE?.oi || 0,
        isMaxPain: row.strike === maxPain, // ✅ highlight flag
      }));
  }, [rows, maxPain]);
  const companyName = stockName?.company;
  const displayName = formattedType === "INDEX" ? formattedSymbol : companyName;

  const displayInstrument = formattedSymbol;

  return (
    <>
      <div className="back-btn">
        <button className="rec-btn" onClick={() => navigate(-1)}>
          Back
        </button>
      </div>
      {loading && (
        <p
          style={{
            fontSize: "1rem",
            fontWeight: "700",
            // color: "white",
            display: "flex",
            gap: "1rem",
          }}
        >
          Fetching Live data..{" "}
          <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
            <FaSpinner />
          </span>
        </p>
      )}
      {/* {!loading && error && (
        <div
          style={{
            marginTop: "20px",
            padding: "14px",
            borderLeft: "5px solid #dc2626",
            background: "#fee2e2",
            color: "#7f1d1d",
            fontWeight: 600,
            borderRadius: "8px",
          }}
        >
          ❌ Main Pain data not available
        </div>
      )} */}
      {error && !loading && !optionData && (
        <div className="option-error">{error}</div>
      )}
      {!loading && pcr && (
        <>
          <div className="maxpain-container">
            <div
              className="grid-1  maxpain-grid"
              style={{
                // display: "flex",
                // flexDirection: "column",
                width: "50%",
                gap: "10px",
                textAlign: "left",
                marginTop: "10px",
                boxShadow: "rgba(0, 0, 0, 0.4) 0px 4px 12px",
              }}
            >
              <p>
                {<p>{displayName}</p>}

                <span
                  className="stock-tag"
                  style={{ width: "max-content", margin: "auto" }}
                >
                  {displayInstrument}
                </span>
              </p>
              <p>
                LTP
                <span
                  style={{
                    fontWeight: "700",
                    // color: "#00b3ff",
                    backgroundColor: " #e6f0ff",
                    color: " #0062ff",
                    padding: "4px 10px",
                    borderRadius: "8px",
                    width: "max-content",
                    margin: "auto",
                  }}
                >
                  {" "}
                  {underlying}
                </span>
              </p>

              <p>
                Max Pain{" "}
                <span
                  style={{
                    fontWeight: "700",
                    background: "rgb(37, 99, 235)",
                    color: "white",

                    padding: "4px 10px",
                    borderRadius: "8px",
                    width: "max-content",
                    margin: "auto",
                  }}
                >
                  {maxPain}
                </span>
              </p>
            </div>
          </div>

          <div>
            <MaxPainChart
              data={oiChartData}
              maxPain={maxPain}
              processed={rows}
              index={displayInstrument}
            />
          </div>

          <div className="ce-pe">
            <div className="ce-pe1">
              <div>
                <h3>Ltp ({maxPain} CE)</h3>

                <div
                  className="ce-pe2"
                  style={{
                    background:
                      ceMaxRow?.ltpPercent > 0 ? "#d4f7e6" : "#ffd4d4",
                    color: ceMaxRow?.ltpPercent >= 0 ? "#008A3E" : "#C53030",
                  }}
                >
                  {ceMaxRow?.ltp ?? "-"}{" "}
                  {ceMaxRow?.ltpPercent >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ opacity: 0.8 }}>
                    {ceMaxRow?.ltpPercent !== undefined
                      ? ceMaxRow.ltpPercent.toFixed(2) + "%"
                      : "-"}
                  </span>
                </div>
              </div>

              <div className="sub-grid">
                <h3>Open Interest</h3>

                <div
                  className="ce-pe2"
                  style={{
                    background: ceMaxRow?.oiPercent > 0 ? "#d4f7e6" : "#ffd4d4",
                    color: ceMaxRow?.oiPercent > 0 ? "#008A3E" : "#C53030",
                  }}
                >
                  {formatNumber(ceMaxRow?.oi) ?? "-"}{" "}
                  {ceMaxRow?.oiPercent >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ opacity: 0.8 }}>
                    {ceMaxRow?.oiPercent !== undefined
                      ? ceMaxRow.oiPercent.toFixed(2) + "%"
                      : "-"}
                  </span>
                </div>
              </div>
              {/* Old code for built up */}
              {/* <div className="sub-grid">
                            <h3>Built Up</h3>
                            <div
                              className="ce-pe2"
                              style={{
                                backgroundColor: builtUpStyleCE.bg,
                                color: builtUpStyleCE.color,
                              }}
                            >
                              {ceMaxRowBuiltUp}
                            </div>
                          </div> */}
              <div className="sub-grid">
                <h3>Built Up</h3>

                <div
                  className="ce-pe2 builtup-box"
                  style={{
                    backgroundColor: ceBuiltUpMeta?.bg || "#f2f2f2",
                    color: ceBuiltUpMeta?.color || "#444",
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  {ceBuiltUp}

                  {/* 🔹 Hover tooltip */}
                  {ceBuiltUpMeta && (
                    <div className="builtup-tooltip">
                      <strong>{ceBuiltUpMeta.label}</strong>
                      <div>{ceBuiltUpMeta.description}</div>
                      <div>
                        Signal:{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            color:
                              ceBuiltUpMeta.signal === "Bullish"
                                ? "#008A3E"
                                : "#C53030",
                          }}
                        >
                          {ceBuiltUpMeta.signal}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="ce-pe1">
              <div>
                <h3>Ltp ({maxPain} PE)</h3>

                <div
                  className="ce-pe2"
                  style={{
                    background:
                      peMaxRow?.ltpPercent > 0 ? "#d4f7e6" : "#ffd4d4",
                    color: peMaxRow?.ltpPercent > 0 ? "#008A3E" : "#C53030",
                  }}
                >
                  {peMaxRow?.ltp ?? "-"}{" "}
                  {peMaxRow?.ltpPercent >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ opacity: 0.8 }}>
                    {peMaxRow?.ltpPercent !== undefined
                      ? peMaxRow.ltpPercent.toFixed(2) + "%"
                      : "-"}
                  </span>
                </div>
              </div>

              {/* OI box */}
              <div className="sub-grid">
                <h3>Open Interest</h3>

                <div
                  className="ce-pe2"
                  style={{
                    background: peMaxRow?.oiPercent > 0 ? "#d4f7e6" : "#ffd4d4",
                    color: peMaxRow?.oiPercent > 0 ? "#008A3E" : "#C53030",
                  }}
                >
                  {formatNumber(peMaxRow?.oi) ?? "-"}
                  {peMaxRow?.oiPercent >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ opacity: 0.8 }}>
                    {peMaxRow?.oiPercent !== undefined
                      ? peMaxRow.oiPercent.toFixed(2) + "%"
                      : "-"}
                  </span>
                </div>
              </div>
              {/* <div className="sub-grid">
                            <h3>Built Up</h3>
                            <div
                              className="ce-pe2"
                              style={{
                                backgroundColor: builtUpStylePE.bg,
                                color: builtUpStylePE.color,
                              }}
                            >
                              {peMaxRowBuiltUp}
                            </div>
                          </div> */}
              <div className="sub-grid">
                <h3>Built Up</h3>

                <div
                  className="ce-pe2 builtup-box"
                  style={{
                    backgroundColor: peBuiltUpMeta?.bg || "#f2f2f2",
                    color: peBuiltUpMeta?.color || "#444",
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  {peBuiltUp}

                  {peBuiltUpMeta && (
                    <div className="builtup-tooltip">
                      <strong>{peBuiltUpMeta.label}</strong>
                      <div>{peBuiltUpMeta.description}</div>
                      <div>
                        Signal:{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            color:
                              peBuiltUpMeta.signal === "Bullish"
                                ? "#008A3E"
                                : "#C53030",
                          }}
                        >
                          {peBuiltUpMeta.signal}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div style={{ display: "flex", gap: "1.5rem" }}>
            <div className="grid call-grid" style={{ width: "50%" }}>
              <div className="sub-grid">
                <h3>Ltp ({maxPain} CE)</h3>

                <div
                  style={{
                    background:
                      ceMaxRow?.ltpPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                    color: ceMaxRow?.ltpPercent >= 0 ? "#008A3E" : "#C53030",
                    marginTop: "15px",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {ceMaxRow?.ltp ?? "-"}{" "}
                  {ceMaxRow?.ltpPercent >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ fontSize: "16px", opacity: 0.8 }}>
                    {ceMaxRow?.ltpPercent !== undefined
                      ? ceMaxRow.ltpPercent.toFixed(2) + "%"
                      : "-"}
                  </span>
                </div>
              </div>

              <div className="sub-grid">
                <h3>Open Interest</h3>
                <div
                  style={{
                    background:
                      ceMaxRow?.oiPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                    color: ceMaxRow?.oiPercent >= 0 ? "#008A3E" : "#C53030",
                    marginTop: "15px",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {formatNumber(ceMaxRow?.oi) ?? "-"}{" "}
                  {ceMaxRow?.oiPercent >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ fontSize: "16px", opacity: 0.8 }}>
                    {ceMaxRow?.oiPercent !== undefined
                      ? ceMaxRow.oiPercent.toFixed(2) + "%"
                      : "-"}
                  </span>
                </div>
              </div>

              <div className="sub-grid">
                <h3>Built Up</h3>

                <div
                  className="ce-pe2 builtup-box"
                  style={{
                    backgroundColor: ceBuiltUpMeta?.bg || "#f2f2f2",
                    color: ceBuiltUpMeta?.color || "#444",
                    position: "relative",
                    cursor: "pointer",
                    marginTop: "10px",
                  }}
                >
                  {ceBuiltUp}

                  {/* 🔹 Hover tooltip */}
                  {ceBuiltUpMeta && (
                    <div className="builtup-tooltip">
                      <strong>{ceBuiltUpMeta.label}</strong>
                      <div>{ceBuiltUpMeta.description}</div>
                      <div>
                        Signal:{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            color:
                              ceBuiltUpMeta.signal === "Bullish"
                                ? "#008A3E"
                                : "#C53030",
                          }}
                        >
                          {ceBuiltUpMeta.signal}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="grid call-grid" style={{ width: "50%" }}>
              <div className="sub-grid">
                <h3>Ltp ({maxPain} PE)</h3>

                <div
                  style={{
                    background:
                      peMaxRow?.ltpPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                    color: peMaxRow?.ltpPercent >= 0 ? "#008A3E" : "#C53030",
                    marginTop: "15px",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {peMaxRow?.ltp ?? "-"}{" "}
                  {peMaxRow?.ltpPercent >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ fontSize: "16px", opacity: 0.8 }}>
                    {peMaxRow?.ltpPercent !== undefined
                      ? peMaxRow.ltpPercent.toFixed(2) + "%"
                      : "-"}
                  </span>
                </div>
              </div>

              <div className="sub-grid">
                <h3>Open Interest</h3>
                <div
                  style={{
                    background:
                      peMaxRow?.oiPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                    color: peMaxRow?.oiPercent >= 0 ? "#008A3E" : "#C53030",
                    marginTop: "15px",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {formatNumber(peMaxRow?.oi) ?? "-"}
                  {peMaxRow?.oiPercent >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ fontSize: "16px", opacity: 0.8 }}>
                    {peMaxRow?.oiPercent !== undefined
                      ? peMaxRow.oiPercent.toFixed(2) + "%"
                      : "-"}
                  </span>
                </div>
              </div>

              {/* <div className="sub-grid">
                                      <h3>Built Up</h3>
                                      <div
                                        style={{
                                          backgroundColor: builtUpStylePE.bg,
                                          color: builtUpStylePE.color,
                                          marginTop: "15px",
                                          padding: "10px 12px",
                                          borderRadius: "8px",
                                          fontWeight: "700",
                                          fontSize: "15px",
                                          display: "flex",
                                          gap: "10px",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        {peMaxRowBuiltUp}
                                      </div>
                                    </div> */}
              <div className="sub-grid">
                <h3>Built Up</h3>

                <div
                  className="ce-pe2 builtup-box"
                  style={{
                    backgroundColor: peBuiltUpMeta?.bg || "#f2f2f2",
                    color: peBuiltUpMeta?.color || "#444",
                    position: "relative",
                    cursor: "pointer",
                    marginTop: "10px",
                  }}
                >
                  {peBuiltUp}

                  {peBuiltUpMeta && (
                    <div className="builtup-tooltip">
                      <strong>{peBuiltUpMeta.label}</strong>
                      <div>{peBuiltUpMeta.description}</div>
                      <div>
                        Signal:{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            color:
                              peBuiltUpMeta.signal === "Bullish"
                                ? "#008A3E"
                                : "#C53030",
                          }}
                        >
                          {peBuiltUpMeta.signal}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default MaxPainPage;
